// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'cpu-chip';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M4.219 3.156h9.562s1.063 0 1.063 1.063v9.562s0 1.063-1.063 1.063H4.22s-1.063 0-1.063-1.063V4.22s0-1.063 1.063-1.063zm4.781 0V1.562M5.281 3.156V1.562m7.438 1.594V1.562M9 16.438v-1.594m-3.719 1.594v-1.594m7.438 1.594v-1.594M16.438 9h-1.594m1.594 3.719h-1.594m1.594-7.438h-1.594M3.156 9H1.562m1.594 3.719H1.562m1.594-7.438H1.562' />
    <path d='M6.344 5.281h5.312s1.063 0 1.063 1.063v5.312s0 1.063-1.063 1.063H6.344s-1.063 0-1.063-1.063V6.344s0-1.063 1.063-1.063zm4.25 5.313H9' />
  </g>
);

export const viewBox = '0 0 18 18';
